<donut-filter v-model="filteredStatuses" :options="options" fallback="All Statuses"></donut-filter>